import React from 'react';
import axios from 'axios';
import ajax from '../../helpers/ajax';
import RenderFormCliente from './RenderFormCliente';

export default class ContainerFormCliente extends React.Component {
	constructor(props) {
		super(props);
		this.onSubmitCliente = this.onSubmitCliente.bind(this);
		
		this.state = {
			mostrarMensajeDeEnvio:false,
		};
	}

	onSubmitCliente(values){
		axios
		.post('/api/v1/formCliente/',{
			nombreApellido:values.nombreApellido,
			telefono:values.telefono,
			email:values.email,
			area:values.area,
			referencia:values.referencia,
			localidad:values.localidad,
			mensaje:values.mensaje,
		})
		.then(result => {
			this.setState({ mostrarMensajeDeEnvio: true })
		}) 
		.catch((err) => console.log(err));
	}

	render(){
		return <RenderFormCliente
			onSubmit={this.onSubmitCliente}
			mostrarMensajeDeEnvio={this.state.mostrarMensajeDeEnvio}
			to={this.props.to}
			referencia={this.props.referencia}
			hacia={this.props.hacia}
			accion={this.props.accion}
		/>
	}
}